import React, { Fragment, useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import axios from "axios";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import {
  AWS_IMAGE_FOLDER_MAINFOOTER,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../common/Constant";
import { uploadAWS, uploaPDFAWS } from "../../common/AWSHelper";

function MainFooter({ searchQuery, dynamicModule }) {
  const [visibleOffers, setVisibleOffers] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");

  // Form Values
  const [formValues, setFormValues] = useState({
    Number: "",
    Address: "",
    Email: "",
    FacebookLink: "",
    TwitterLink: "",
    GoogleLink: "",
    InstaLink: "",
    WhatsappNumber: "",
    firstImage: "",
    firstMainContent: "",
    secondImage: "",
    secondMainContent: "",
    thirdImage: "",
    thirdMainContent: "",
    forthImage: "",
    forthMainContent: "",
    fiveImage: "",
    fiveMainContent: "",
    sixImage: "",
    sixMainContent: "",
    sevenImage: "",
    sevenMainContent: "",
    eightImage: "",
    eightMainContent: "",
    nineImage: "",
    nineMainContent: "",
    OpeningHours: "",
    rights: "",
  });

  console.log(formValues, "formValues123000");

  const [dynamicValue, setDynamicValue] = useState("MainSite");

  useEffect(() => {
    if (dynamicModule) {
      setDynamicValue(dynamicModule);
    }
  }, [dynamicModule]);
  // Form Values

  //HandleSubmit For the Form
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      Number: formValues.Number,
      Address: formValues.Address,
      Email: formValues.Email,
      FacebookLink: formValues.FacebookLink,
      TwitterLink: formValues.TwitterLink,
      GoogleLink: formValues.GoogleLink,
      InstaLink: formValues.InstaLink,

      firstImage: formValues.firstImage,
      firstMainContent: formValues.firstMainContent,
      secondImage: formValues.secondImage,
      secondMainContent: formValues.secondMainContent,
      thirdImage: formValues.thirdImage,
      thirdMainContent: formValues.thirdMainContent,
      forthImage: formValues.forthImage,
      forthMainContent: formValues.forthMainContent,
      fiveImage: formValues.fiveImage,
      fiveMainContent: formValues.fiveMainContent,
      sixImage: formValues.sixImage,
      sixMainContent: formValues.sixMainContent,
      sevenImage: formValues.sevenImage,
      sevenMainContent: formValues.sevenMainContent,
      eightImage: formValues.eightImage,
      eightMainContent: formValues.eightMainContent,
      nineImage: formValues.nineImage,
      nineMainContent: formValues.nineMainContent,
      OpeningHours: formValues.OpeningHours,
      rights: formValues.rights,

      from: dynamicValue,
      // WhatsappNumber: formValues.WhatsappNumber,
    };
    setLoading(true);
    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/contactusupsert`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          // navigate("/suppliers");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Email" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
      });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  async function getContactDetails() {
    try {
      const res = await axios.get(
        `${config.ecommconfigBaseUrl}/ecomconfig/commonconfigvalues?configtype=ContactUs&from=${dynamicValue}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );

      const responseData = res.data.ResponseData;

      const getValue = (key) =>
        responseData.find((item) => item.CommonConfigKey === key)
          ?.CommonConfigValue || "";

      const data = {
        Number: getValue("Number"),
        Address: getValue("Address"),
        Email: getValue("Email"),
        FacebookLink: getValue("FacebookLink"),
        TwitterLink: getValue("TwitterLink"),
        GoogleLink: getValue("GoogleLink"),
        InstaLink: getValue("InstagramLink"),
        WhatsappNumber: "", // Commented in original, no value in response

        firstImage: getValue("FirstImage"),
        firstMainContent: getValue("FirstContent"),

        secondImage: getValue("SecondImage"),
        secondMainContent: getValue("SecondContent"),

        thirdImage: getValue("ThirdImage"),
        thirdMainContent: getValue("ThirdContent"),

        forthImage: getValue("FourthImage"),
        forthMainContent: getValue("FourthContent"),

        fiveImage: getValue("FifthImage"),
        fiveMainContent: getValue("FifthContent"),

        sixImage: getValue("SixthImage"),
        sixMainContent: getValue("SixthContent"),

        sevenImage: getValue("SeventhImage"),
        sevenMainContent: getValue("SeventhContent"),

        eightImage: getValue("EighthImage"),
        eightMainContent: getValue("EighthContent"),

        nineImage: getValue("NinthImage"),
        nineMainContent: getValue("NinthContent"),

        OpeningHours: getValue("OpeningHour"), // Corrected key name
        rights: getValue("Rights"), // Assign rights correctly
      };

      console.log(data, "data123");
      setFormValues(data);
    } catch (err) {
      console.error("Failed to fetch contact details", err);
    }
  }

  useEffect(() => {
    getContactDetails();
  }, [dynamicValue]);

  const data = [
    {
      name: "Number",
      input: (
        <>
          <input
            width="350px"
            className="form-control mr-4"
            placeholder="Enter Number Here"
            name="Number"
            onChange={handleChange}
            value={formValues.Number}
          />
        </>
      ),
    },
    {
      name: "Address",
      input: (
        <>
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Address"
            name="Address"
            onChange={handleChange}
            value={formValues.Address}
          />
        </>
      ),
    },
    {
      name: "Email",
      input: (
        <>
          {" "}
          <input
            width="350px"
            className="form-control mr-4"
            placeholder="Enter Email Here"
            name="Email"
            onChange={handleChange}
            value={formValues.Email}
          />
        </>
      ),
    },
    {
      name: "FB Link",
      input: (
        <>
          {" "}
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Button Name"
            name="FacebookLink"
            onChange={handleChange}
            value={formValues.FacebookLink}
          />
        </>
      ),
    },
    {
      name: "Twitter Link",
      input: (
        <>
          {" "}
          <input
            width="350px"
            className="form-control mr-4"
            placeholder="Enter Twitter Link"
            name="TwitterLink"
            onChange={handleChange}
            value={formValues.TwitterLink}
          />
        </>
      ),
    },
    {
      name: "Google Link",
      input: (
        <>
          {" "}
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Google Link"
            name="GoogleLink"
            onChange={handleChange}
            value={formValues.GoogleLink}
          />
        </>
      ),
    },
    {
      name: "Insta Link",
      input: (
        <>
          <input
            width="350px"
            className="form-control mr-4"
            placeholder="Enter Insta Link"
            name="InstaLink"
            onChange={handleChange}
            value={formValues.InstaLink}
          />
        </>
      ),
    },
    // {
    //   name: "Whatsapp Number",
    //   input: (
    //     <>
    //       <input
    //         width="350px"
    //         className="form-control"
    //         placeholder="Enter Whatsapp Number Here"
    //         name="WhatsappNumber"
    //         onChange={handleChange}
    //         value={formValues.WhatsappNumber}
    //       />
    //     </>
    //   ),
    // }
  ];

  // const handleImageChange = async (event, key) => {
  //   const file = event.target.files[0];
  //   console.log("Updating Top Footer data1:", file);

  //   if (file) {
  //     try {
  //       setLoading(true);
  //       await uploadAWS(file, AWS_IMAGE_FOLDER_MAINFOOTER, (data) => {
  //         console.log(data, "imageUrl");
  //         console.log(key, "imageUrl1");
  //         setFormValues((prevValues) => ({ ...prevValues, [key]: data }));
  //         console.log(formValues, "imageUrl11"); // Note: This may log the old state
  //       });
  //       console.log(formValues, "imageUrl111"); // This may also log the old state
  //     } catch (error) {
  //       console.error("Error uploading file:", error);
  //       toastError(ERROR_MESSAGE);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // };

  const handleImageChange = async (event) => {
    const file = event.target.files?.[0];
    const key = event.target.name;

    if (!key || !file) return;

    try {
      setLoading(true);

      // Upload to AWS (you must define this function)
      await uploaPDFAWS(file, AWS_IMAGE_FOLDER_MAINFOOTER, (uploadedUrl) => {
        setFormValues((prev) => ({
          ...prev,
          [key]: uploadedUrl, // set uploaded URL to correct key
        }));
      });
    } catch (error) {
      console.error("Upload failed:", error);
      toastError("File upload failed");
    } finally {
      setLoading(false);
    }
  };

  const imageContentFields = [
    { image: "firstImage", content: "firstMainContent", label: "first" },
    { image: "secondImage", content: "secondMainContent", label: "second" },
    { image: "thirdImage", content: "thirdMainContent", label: "third" },
    { image: "forthImage", content: "forthMainContent", label: "forth" },
    { image: "fiveImage", content: "fiveMainContent", label: "five" },
    { image: "sixImage", content: "sixMainContent", label: "six" },
    { image: "sevenImage", content: "sevenMainContent", label: "seven" },
    { image: "eightImage", content: "eightMainContent", label: "eight" },
    { image: "nineImage", content: "nineMainContent", label: "nine" },
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(searchQuery.toLowerCase());
  });

  console.log(matchesSearchQuery, "matchesSearchQuery5465465");

  return (
    <Fragment>
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">
              <CLink
                className="link"
                onClick={() => setVisibleOffers(!visibleOffers)}
              >
                Main Footer
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleOffers}>
            <div>
              <div className="card-body">
                {formValues && (
                  <>
                    <form onSubmit={handleSubmit}>
                      <div
                        className="p-4"
                        style={{
                          textAlign: "center",
                          // backgroundColor: "blanchedalmond",
                          border: "1px solid rgba(0,0,0,.12)",
                        }}
                      >
                        <div
                          style={{ borderBottom: "1px solid black" }}
                          className="mb-3"
                        >
                          <h6> Main Footer</h6>
                        </div>
                        <div className="row mb-3 pt-3">
                          <h6 className="mb-5"> Contact us</h6>
                          <div className="col-md-12">
                            <div className="row">
                              <div
                                className="mb-5"
                                style={{
                                  width: "100%",
                                  display: "grid",
                                  gridTemplateColumns: "repeat(2,1fr)",
                                  gap: "10px",
                                  textAlign: "left",
                                }}
                              >
                                {matchesSearchQuery &&
                                  matchesSearchQuery?.map((el) => {
                                    return (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "left",
                                        }}
                                      >
                                        <label
                                          className="mt-1 pull-left w-50"
                                          style={{ fontSize: "15px" }}
                                        >
                                          {el.name}
                                        </label>
                                        <div className="col-md-10 text-left">
                                          {el.input}
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>

                              <div className="w-100">
                                <h6 className="mb-4 text-center fw-bold fs-5">
                                  USEFUL LINKS
                                </h6>

                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "15px",
                                  }}
                                >
                                  {imageContentFields.map((field, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "15px",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      {/* Label */}
                                      <label
                                        style={{
                                          minWidth: "80px",
                                          fontWeight: "600",
                                          color: "#333",
                                          flex: "0 0 auto",
                                        }}
                                      >
                                        {field.label.toUpperCase()}
                                      </label>

                                      {/* Text Input */}
                                      <input
                                        className="form-control"
                                        placeholder={`Enter ${field.label} Main Content`}
                                        name={field.content}
                                        onChange={handleChange}
                                        value={formValues[field.content]}
                                        style={{
                                          flex: "1 1 300px",
                                          minWidth: "220px",
                                        }}
                                      />

                                      {/* File Upload */}
                                      <input
                                        type="file"
                                        name={field.image}
                                        className="form-control"
                                        onChange={handleImageChange}
                                        style={{
                                          flex: "1 1 200px",
                                          minWidth: "180px",
                                        }}
                                      />

                                      {/* File Link */}
                                      {formValues[field.image] && (
                                        <a
                                          href={formValues[field.image]}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            color: "#0d6efd",
                                            fontSize: "14px",
                                            textDecoration: "underline",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          Click to check URL
                                        </a>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </div>

                              <div className="d-flex align-items-center gap-2 mt-5 w-100">
                                <h6 className="text-black fw-bold fs-5">
                                  Rights Reserved
                                </h6>
                                <div>
                                  <input
                                    placeholder="add here you site rights"
                                    name="rights"
                                    value={formValues?.rights}
                                    onChange={(event) => {
                                      setFormValues((prev) => ({
                                        ...prev,
                                        rights: event.target.value,
                                      }));
                                    }}
                                    style={{minWidth: "500px"}}
                                    className="form-control w-100"
                                  />
                                </div>
                              </div>

                              <div className="mt-5 w-100">
                                <h6 className="mb-4 text-center fw-bold fs-5">
                                  OPENING HOURS
                                </h6>

                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "15px",
                                  }}
                                >
                                  <textarea
                                    name="OpeningHours"
                                    onChange={handleChange}
                                    value={formValues?.OpeningHours}
                                    rows="5"
                                    cols="30"
                                    style={{
                                      fontFamily: "monospace",
                                      textTransform: "uppercase",
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-md-10"></div>
                            </div>
                          </div>
                        </div>

                        <div></div>

                        <div className="d-flex justify-content-center mt-3">
                          <button
                            type="submit"
                            className="btn btn-primary mb-3"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  className="link"
                  onClick={() => setVisibleOffers(!visibleOffers)}
                >
                  Main Footer
                </CLink>
              </h5>
            </div>
            <CCollapse visible={visibleOffers}>
              <div className="card-body">
                {formValues && (
                  <>
                    <form onSubmit={handleSubmit}>
                      <div
                        className="container"
                        style={{
                          textAlign: "center",
                          // backgroundColor: "blanchedalmond",
                          border: "1px solid rgba(0,0,0,.12)",
                        }}
                      >
                        <div className="row mb-3 pt-3">
                          <div className="col-md-6">
                            <div className="row">
                              <div
                                // className="col-md-2"
                                style={{
                                  width: "100%",
                                  display: "grid",
                                  gridTemplateColumns: "repeat(2,1fr)",
                                  gap: "10px",
                                }}
                              >
                                {matchesSearchQuery &&
                                  matchesSearchQuery?.map((el) => {
                                    return (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <label
                                          className="mt-1 pull-left w-50"
                                          style={{ fontSize: "15px" }}
                                        >
                                          {el.name}
                                        </label>
                                        <div className="col-md-10 text-left">
                                          {el.input}
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                              <div className="col-md-10"></div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-center mt-3">
                          <button
                            type="submit"
                            className="btn btn-primary mb-3"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </CCollapse>
          </div>
        )
      )}
    </Fragment>
  );
}

export default MainFooter;
